import request from '@/utils/request'


// 查询产品分类列表
export function listCategory(query) {
  return request({
    url: '/user/category/list',
    method: 'get',
    params: query
  })
}

// 查询产品分类分页
export function pageCategory(query) {
  return request({
    url: '/user/category/page',
    method: 'get',
    params: query
  })
}

// 查询产品分类详细
export function getCategory(data) {
  return request({
    url: '/user/category/detail',
    method: 'get',
    params: data
  })
}

// 新增产品分类
export function addCategory(data) {
  return request({
    url: '/user/category/add',
    method: 'post',
    data: data
  })
}

// 修改产品分类
export function updateCategory(data) {
  return request({
    url: '/user/category/edit',
    method: 'post',
    data: data
  })
}

// 删除产品分类
export function delCategory(data) {
  return request({
    url: '/user/category/delete',
    method: 'post',
    data: data
  })
}

// 更新产品分类排序（仅更新 sort）
export function updateCategorySort(data) {
  return request({
    url: '/user/category/update-sort',
    method: 'post',
    data: data
  })
}

// 更新产品分类状态（仅更新 status）
export function updateCategoryStatus(data) {
  return request({
    url: '/user/category/update-status',
    method: 'post',
    data: data
  })
}
